module.exports = __webpack_public_path__ + "static/NBEC-logo-7ce2e36ffffdf73bdb38fbe93a3d61ed.png";